import React from 'react';
import styled from 'styled-components';
import theme from '../../theme';
import { lighten } from 'polished'

const Button = React.forwardRef((props, ref) => (
  <StyledButton ref={ref} disabled={props.disabled} onClick={props.onClick}>
    {props.text}
  </StyledButton>
));

const StyledButton = styled.button`
  background: ${theme.colors.primary};
  appearance: none;
  -webkit-appearance: none;
  border: none;
  color: white;
  text-transform: uppercase;
  padding: 8px 30px;
  transition: background .3s ease;

  &:hover {
    background: ${lighten(.1, theme.colors.primary)}
  }

  &:focus,
  &:active {
    outline: none;
  }
`;

export default Button;